/**
 * Constants for RiseAI Chat component
 */

export const DRAWER_WIDTH = '1200px';

export const CATEGORIES = ['All', 'Vulnerabilities', 'SBOM', 'Licenses', 'Cryptography', 'Binaries', 'Secrets'];

export const RISE_AI_APP_NAME = 'rise_ai_llm_agent';

export const RISE_AI_STATUS = {
  UNSPECIFIED: 'UNSPECIFIED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
  ELIGIBLE: 'ELIGIBLE'
};

/**
 * ADK Event Types (normalized to match AG-UI-like structure)
 */
export const ADK_EVENT_TYPES = {
  TEXT_MESSAGE_START: 'TEXT_MESSAGE_START',
  TEXT_MESSAGE_CONTENT: 'TEXT_MESSAGE_CONTENT',
  TEXT_MESSAGE_END: 'TEXT_MESSAGE_END',
  TOOL_CALL_START: 'TOOL_CALL_START',
  TOOL_CALL_RESULT: 'TOOL_CALL_RESULT',
  TOOL_CALL_END: 'TOOL_CALL_END',
  RUN_FINISHED: 'RUN_FINISHED',
  ERROR: 'ERROR',
  UNKNOWN: 'UNKNOWN'
};

/**
 * ADK Author constants
 * These represent the different agents/authors that can process events in the ADK system
 * Currently only includes authors that are actively used in adkEventParser.js
 */
export const ADK_AUTHORS = {
  // Retrieval flow agents
  DATA_ROUTER: 'data_router',
  PRESENTER: 'presenter',
  
  // Main orchestration agents
  METADATA_ANSWER: 'metadata_answer',
  DIRECT_ANSWER: 'direct_answer',
  
  // Vulnerability remediation flow agents
  REMEDIATION_PROPOSER: 'remediation_proposer',
  REMEDIATION_CONFIRMATION: 'remediation_confirmation',
  REMEDIATION_SUMMARY: 'remediation_summary'
};
